module.exports = __webpack_public_path__ + "static/media/016.ddc5e239.jpg";